import React from "react";
import { Link, useNavigate } from "react-router-dom";
import order from "./asserts/orders.jpg";

const Topbar = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    navigate('/');
  };

  return (
    <nav className="bg-gradient-info text-light">
      <div className="container-fluid d-flex justify-content-between align-items-center">
        <img src={order} style={{ height: "80px", width: "200px" }} alt="" />
        <div>
          <button onClick={handleLogout} className="btn btn-facebook mr-5">Logout</button>
        </div>
      </div>
    </nav>
  );
};


export default Topbar;
